import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Qs from 'qs';

import Conf from 'utils/Conf';
import { Button } from '@material-ui/core';

const FreeBooking = ({
  seanceId,
  coupon,

  // onClose,
  onOk,
  // go,
  // email,
  // locale,
  // conf,
  // onErreur,
}) => {
  const { t } = useTranslation();

  const handleBook = () => {
    const params = coupon ? { discount_code: coupon.value } : {};
    axios.post(`${Conf.apiBaseUriLegacy}/book/${seanceId}`, Qs.stringify({}), { params, withCredentials: true })
      .then((res) => {
        if (res.data.status === 'OK') {
          onOk();
          // methods.getProfile();
        }
      });
  };


  return (
    <Button
      onClick={handleBook}
      className="seance-btn"
      size="small"
      variant="contained"
      color="primary"
    >
      {t('reserver')}
    </Button>
  );
};


export default FreeBooking;
